import React from 'react'

const ShopfloMonogram: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox='0 0 22 28'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden='true'
  >
    <path d='M16.5755 4.92879L7.56566 13.9336C5.83504 15.6633 3.02859 15.6633 1.29797 13.9336C-0.432656 12.204 -0.432656 9.39911 1.29797 7.66945L7.17455 1.79724C8.90518 0.0675854 11.7116 0.0675854 13.4422 1.79724L16.5755 4.92879Z' />
    <path d='M4.47559 22.5326L13.4855 13.5278C15.2161 11.7981 18.0225 11.7981 19.7531 13.5278C21.4838 15.2574 21.4838 18.0623 19.7531 19.792L13.8777 25.6642C12.1471 27.3938 9.34061 27.3938 7.60998 25.6642L4.47669 22.5326H4.47559Z' />
  </svg>
)

export default ShopfloMonogram
